import { render, staticRenderFns } from "./OrderDuration.vue?vue&type=template&id=19da8066&scoped=true"
import script from "./OrderDuration.vue?vue&type=script&lang=js"
export * from "./OrderDuration.vue?vue&type=script&lang=js"
import style0 from "./OrderDuration.vue?vue&type=style&index=0&id=19da8066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da8066",
  null
  
)

export default component.exports